import get from 'lodash/get';
import merge from 'lodash/merge';
import * as asyncUtils from 'ui-permit/shared-components/utils/async';
import { SHARED_PREFIX, SET_IMAGE_URL } from '../constants';

export const getReservationSummaryImageUrlReducer = (state, action) => {
    if (action.type === SHARED_PREFIX + SET_IMAGE_URL) {
        return merge(state, {reservationSummaryImageUrl: action.payload});
    }
    return state
};

const INITIAL_STATE = {
  reservationSummaryImageUrl: ''
};

const shared = asyncUtils.mergeReducers(INITIAL_STATE, SHARED_PREFIX,
  getReservationSummaryImageUrlReducer
);

export default shared;

export const selectors = {
  getImageUrlSelector: (state) => get(state, 'permitShared.reservationSummaryImageUrl', '')
};
